import angular from "angular";

const users = function ($resource) {
    'ngInject';

    return $resource('/api/v1/public/accounts/:path/:token', {}, {
        bicycleOwner: {
            method: "POST",
            params: {path: "bicycle-owner"},
            headers: {
                'g-recaptcha-response': function (config) {
                    let recapcha = config.data.gRecaptchaResponse;
                    delete config.data.gRecaptchaResponse;
                    return recapcha;
                },
                'g-recaptcha-action': function (config) {
                    let recaptchaAction = config.data.gRecaptchaAction;
                    delete config.data.gRecaptchaAction;
                    return recaptchaAction;
                }
            },
            isArray: false
        },
        serviceProvider: {
            method: "POST",
            params: {path: "service-provider"},
            headers: {
                'g-recaptcha-response': function (config) {
                    let recapcha = config.data.gRecaptchaResponse;
                    delete config.data.gRecaptchaResponse;
                    return recapcha;
                },
                'g-recaptcha-action': function (config) {
                    let recaptchaAction = config.data.gRecaptchaAction;
                    delete config.data.gRecaptchaAction;
                    return recaptchaAction;
                }
            },
            isArray: false
        },
        forgotPassword: {
            method: "POST",
            params: {path: "forgot-password"},
            isArray: false
        },
        resetPassword: {
            method: "PUT",
            params: {path: "reset-password"},
            isArray: false
        },
        activateAccount: {
            method: "PUT",
            params: {path: "activate"},
            isArray: false
        },
        acceptInvite: {
            method: "PUT",
            params: {path: "accept-invite"},
            isArray: false
        },
        confirmRegistration: {
            method: "GET",
            params: {path: "confirm-registration"},
            isArray: false
        },
        cancelRegistration: {
            method: "GET",
            params: {path: "cancel"},
            isArray: false
        },
        completeRegistration: {
            method: "PUT",
            params: {path: "complete-registration"},
            isArray: false
        }
    })
}

export default angular.module('vt-public-resource.users', [])
    .service('UsersPublicApi', users);
